(ns practitest.frontend.requirements.inherit-fields
  (:require [ajax.core :as ajax]
            [clojure.string :as str]
            [practitest.frontend.common-entities :refer [prepare-full-selection-ids]]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.events :as events]
            [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.subs :as subs]
            [re-frame.core :as re-frame]))

(def storage-key "pt-testset-inherit-prefill")

;; navigate! must stay a closure built where get-url-view is called (a reagent render
;; context) - get-url-view warns/breaks when called from a plain event handler like this one.
(re-frame/reg-event-fx
  ::got-response
  (fn [_ [_ navigate! {:keys [fields]}]]
    (when (seq fields)
      (dom/set-session-item storage-key (pr-str fields)))
    (navigate!)
    nil))

;; navigate! is only called once the backend confirms the instance limit - never on error.
(re-frame/reg-event-fx
  ::check-and-navigate
  (fn [{db :db} [_ {:keys [selection current-view filter navigate!]}]]
    (let [ids (prepare-full-selection-ids selection current-view)]
      {:http-xhrio
       {:method :get
        :uri (broutes/get-url "suites#new_from_requirements"
                              {:p_id (subs/get-current-project-id db)}
                              (cond-> {:ids ids}
                                (str/starts-with? ids "_") (assoc :filter filter)))
        :response-format (ajax/json-response-format {:keywords? true})
        :on-success [::got-response navigate!]
        :on-failure [::events/api-error ::check-and-navigate {}]}})))
